__turbopack_context__.v({
  "dialog": "Dialog-module__bHxKhW__dialog",
  "dialogExtraWide": "Dialog-module__bHxKhW__dialogExtraWide",
  "dialogFullScreen": "Dialog-module__bHxKhW__dialogFullScreen",
  "dialogFullScreenScrollable": "Dialog-module__bHxKhW__dialogFullScreenScrollable",
  "dialogNarrow": "Dialog-module__bHxKhW__dialogNarrow",
  "dialogTall": "Dialog-module__bHxKhW__dialogTall",
  "dialogWide": "Dialog-module__bHxKhW__dialogWide",
  "dialog__header": "Dialog-module__bHxKhW__dialog__header",
  "dialog__header_buttons": "Dialog-module__bHxKhW__dialog__header_buttons",
  "dialog__header_complex": "Dialog-module__bHxKhW__dialog__header_complex",
  "modalFadeIn": "Dialog-module__bHxKhW__modalFadeIn",
});
